import {AppStore} from "../../desktop"
import {User} from "../../models/User"
import {UsersActionTypes} from "./types"
import {actionSetTabItem} from "../tabs/actions"
import {TabsActionTypes} from "../tabs"


export const actionUserFetchAll = () => {
	AppStore.dispatch({type: UsersActionTypes.FETCH_ALL_REQUEST, payload: null})
}

export const actionUserFetchAllCompleted = (users: User[]) => {
	AppStore.dispatch({type: UsersActionTypes.FETCH_ALL_COMPLETED, payload: users})
}

export const actionUserFetch = (user: User) => {
	AppStore.dispatch({type: UsersActionTypes.FETCH_ONE_REQUEST, payload: user})
}

export const actionUserFetchCompleted = (user: User) => {
	AppStore.dispatch({type: UsersActionTypes.FETCH_ONE_COMPLETED, payload: user})
	AppStore.dispatch({type: TabsActionTypes.SET_TAB_ITEM, payload: user})
}

export const actionUserSave = (user: User) => {
	AppStore.dispatch({type: UsersActionTypes.SAVE_REQUEST, payload: user})
}

export const actionUserSaveCompleted = (user: User) => {
	AppStore.dispatch({type: UsersActionTypes.SAVE_COMPLETED, payload: user})
}

export const actionUserDelete = (user: User) => {
	AppStore.dispatch({type: UsersActionTypes.DELETE_REQUEST, payload: user})
}

export const actionUserDeleteCompleted = (user: User) => {
	AppStore.dispatch({type: UsersActionTypes.DELETE_COMPLETED, payload: user})
}

export const actionDeleteUsers = (users: User[]) => {
	AppStore.dispatch({type: UsersActionTypes.DELETE_MULTIPLE_REQUEST, payload: users})
}

export const actionDeleteUsersCompleted = (users: User[]) => {
	AppStore.dispatch({type: UsersActionTypes.DELETE_MULTIPLE_COMPLETED, payload: users})
}
